import * as CookieConsent from 'vanilla-cookieconsent';
import { gsap, SplitText } from '../../global/gsap';

const initSplash = (element) => {
    const splashPlayed = sessionStorage.getItem('splashShown');

    if (splashPlayed) {
        element.remove();
    } else {
        const close = element.querySelector('.js-splash-close');
        const line = element.querySelector('.js-splash-line');

        let tagline = element.querySelector('.js-splash-tagline');
        let wordStagger = 0.025;

        // If user in Oceania, show different tagline
        if (document.body.dataset.continent === 'OC') {
            tagline = element.querySelector('[data-geo="oceania"]');
            wordStagger = 0.05;
        }

        const split = new SplitText(tagline, {
            type: 'words',
            linesClass: 'line++'
        });

        if (document.body.dataset.continent === 'OC') {
            gsap.set(split.words, {
                y: 0,
                opacity: 0
            });
        } else {
            gsap.set(split.words, {
                y: '50%',
                opacity: 0
            });
        }

        gsap.set([line, tagline], {
            opacity: 1
        });

        const splashTl = gsap.timeline({
            defaults: {
                ease: 'power3',
                duration: 0.2 * split.words.length
            },
            onStart: () => {
                window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
                document.body.classList.add('stop-scrolling');
            },
            onComplete: () => {
                document.body.classList.remove('stop-scrolling');
                element.classList.add('finish');
                sessionStorage.setItem('splashShown', true);

                // Check if cookie manager hasn't been responded to
                if (!document.cookie.split(';').some((item) => item.trim().startsWith('cc_cookie='))) {
                    CookieConsent.show();
                }
            }
        });

        splashTl.to(split.words, {
            y: 0,
            opacity: 1,
            delay: 0.25,
            stagger: wordStagger
        }).to(line, {
            duration: 1,
            scaleX: 1
        }).to(line, {
            duration: 0.5,
            delay: 0.5,
            y: '100%'
        });

        close.addEventListener('click', (event) => {
            event.preventDefault();

            splashTl.pause();

            document.body.classList.remove('stop-scrolling');
            element.classList.add('finish');
            sessionStorage.setItem('splashShown', true);

            // Check if cookie manager hasn't been responded to
            if (!document.cookie.split(';').some((item) => item.trim().startsWith('cc_cookie='))) {
                CookieConsent.show();
            }
        });
    }
};

export { initSplash as default };
